import { render, staticRenderFns } from "./LogoutPage.vue?vue&type=template&id=669ec66a&scoped=true&"
import script from "./LogoutPage.vue?vue&type=script&lang=js&"
export * from "./LogoutPage.vue?vue&type=script&lang=js&"
import style0 from "./LogoutPage.vue?vue&type=style&index=0&id=669ec66a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669ec66a",
  null
  
)

export default component.exports